/**
 * Matching prioritario: el item activo es aquel cuyo `to` es el **prefijo
 * más largo** que coincide con `pathname`. Esto evita que `/sessions/mine`
 * active a la vez "Explorar" (prefijo `/sessions`) y "Mis partidas"
 * (prefijo `/sessions/mine`).
 *
 * Reglas:
 *  - `to === '/'` solo matchea pathname exacto `/` (si no, `'/'` sería
 *    prefijo de TODO).
 *  - El resto matchea por prefijo exacto o seguido de `/` (evita que
 *    `/sessions` matchee `/sessions2`).
 *
 * Vive en su propio fichero (no en MobileTabBar.tsx) para que React Fast
 * Refresh funcione correctamente en MobileTabBar — ESLint exige que un
 * archivo de componente solo exporte componentes.
 */
export function pickActivePath(pathname: string, candidates: string[]): string | null {
  let best: string | null = null
  for (const to of candidates) {
    if (to === '/') {
      if (pathname === '/') {
        if (best === null) best = to
      }
      continue
    }
    if (pathname === to || pathname.startsWith(`${to}/`)) {
      if (best === null || to.length > best.length) best = to
    }
  }
  return best
}
